import { SidebarContent, SidebarHeader, SidebarMenuButton } from '@quadminds/mindkit';
import { MindyDocRoles, MindyRolesPermissions, MindyStandardRoles } from '@quadminds/mindy-shared';
import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

export function SettingsSidebar() {
    const navigate = useNavigate();
    const location = useLocation();

    const { t } = useTranslation();
    const queryClient = useQueryClient(); // Access the query client
    const userInfo: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']); // Retrieve userInfo from the cache
    const permissions = userInfo?.permissions || [];
    const roles = userInfo?.roles || [];
    return (
        <div className="flex flex-col space-y-4 h-full border-r border-gray-qm-50 bg-gray-qm-50/50 dark:bg-gray-qm-900 dark:border-gray-qm-800 p-4">
            <SidebarHeader>
                <h2 className="text-lg font-semibold font-poppins">{t('settings.title')}</h2>
            </SidebarHeader>
            <SidebarContent>
                {(roles.includes(MindyStandardRoles.ADMIN) || roles.includes(MindyDocRoles.ADMIN_DOC)) && (
                    <SidebarMenuButton
                        className={`font-poppins font-medium transition ${
                            location.pathname === '/settings/users'
                                ? '!bg-primary !text-white'
                                : 'hover:bg-gray-qm-50 hover:dark:bg-gray-qm-800'
                        }`}
                        onClick={() => navigate('/settings/users')}
                    >
                        <span className="text-sm">{t('settings.user.title')}</span>
                    </SidebarMenuButton>
                )}
                {permissions.includes(MindyRolesPermissions.ReadRole) && (
                    <SidebarMenuButton
                        className={`font-poppins font-medium transition ${
                            location.pathname === '/settings/roles'
                                ? '!bg-primary !text-white'
                                : 'hover:bg-gray-qm-50 hover:dark:bg-gray-qm-800'
                        }`}
                        onClick={() => navigate('/settings/roles')}
                    >
                        <span className="text-sm">{t('settings.roles.title')}</span>
                    </SidebarMenuButton>
                )}
                {roles.includes(MindyStandardRoles.ADMIN) && (
                    <SidebarMenuButton
                        className={`font-poppins font-medium transition ${
                            location.pathname === '/settings/connections'
                                ? '!bg-primary !text-white'
                                : 'hover:bg-gray-qm-50 hover:dark:bg-gray-qm-800'
                        }`}
                        onClick={() => navigate('/settings/connections')}
                    >
                        <span className="text-sm">{t('settings.connections.title')}</span>
                    </SidebarMenuButton>
                )}
            </SidebarContent>
        </div>
    );
}

export default SettingsSidebar;
